import { Clinic } from '../../system/clinic/models/clinic';
import { LoginMenu } from './login-menu';
import { LoginFunction } from './login-function';

export class LoginUser {
  Account:string = '';
  // Token
  AuthToken: string = '';
  SSOToken:string = '';
  ConsoleToken:string = '';
  Clinic: Clinic = new Clinic();
  ClinicName:string = '';
  // Company
  CompanyCode: string = '';
  CompanyName: string = '';

  ExpiresOn: Date;
  // User
  IsAdmin: boolean = false;
  IsSuper: boolean = false;
  UserId: number = 0;
  Name: string = '';
  CId: string = '';
  MedLicense: string = '';
  DeptCode:string = '';
  //Email: string;
  CanChangeDailyReport: boolean = false;
  CanModifyOwn: boolean = false;
  CanRevertStockDocument: boolean = false;
  CanLoginPromptInsufficientInventory: boolean = false;
  // Clinic
  
  Menus: LoginMenu[];
  // 前端只管前端路由是否可存取
  Routes: LoginFunction[];

  get isExpired(): boolean {
    if (new Date(this.ExpiresOn) < new Date()) {
      return true;
    } else {
      return false;
    }
  }
}
